import { Component } from "@angular/core";

@Component({
  selector: "aa-error",
  templateUrl: "./error.component.html",
  host: { class: "anonymous-page" },
  standalone: false,
})
export class ErrorComponent {}
